import React from "react";
import { formatBookingJson, manualGoogleEvents, trackProCardsViewsOnViewport } from "../helpers/helpers";
import CallToActionDescription from "./call-to-action-description";

export default class ProfilesCardsDumpster extends React.Component {



    constructor(props) {
        super(props)

        this.profiles = this.props.profiles.length > 0 ? this.props.profiles : [];
        this.profilesById = this.props.cards
        this.cardsPerPage = 6;
        this.defaultCards = 15;
        // Hub01 to Hub09 limit to 10 cards per page
        if(this.props.place.ht?.includes('Hub')){
			this.defaultCards = 10;
		}
        this.page = 0;

        this.code = this.props.code;
        this.place = this.props.place;
        this.onlineBookingPros = this.props.online_booking_pros;
        this.commercialProjectType = "509"
        this.paginated = this.props.paginated
        this.eventClass = this.props.eventClass || "proCardRendered"
        this.cardClass = this.props.cardClass || "card-pro-view"
    }

    componentDidMount() {
        trackProCardsViewsOnViewport(this.eventClass, this.cardClass, 0);
    }

    addQuote = (id) => {
        if(this.onlineBookingPros.includes(+id) && this.code !== 'comercial-trash-service' && this.code !== 'junk-removal'){
            return(
                <CallToActionDescription 
                    detail=""
                    startVisible={false}
                    proid={id}
                    class="get-a-quote view-prices"
                    ondeffCode='viewPricesForm'
                    btnLabel='View prices & book'
                    callBackAfterSubmit={this.handleCallBackAfterSubmit}
                    onlineBooking={true}
                    proUrl={this.getProUrl(this.profilesById[id])}
                />
            )
        } else {
            if(this.code === 'comercial-trash-service'){
                return (
                    <CallToActionDescription 
                        detail="Request pricing & availability"
                        startVisible={false}
                        proid={id}
                        initialFormData={[{ key: "pro_id", value: id }, { key: "project_type", value: this.commercialProjectType }]}
                        ondeffCode='commercialWasteQuoteRequest'
                        class="get-a-quote"
                    />
                )
            }
            else if(this.code === 'junk-removal'){
                return (
                    <CallToActionDescription 
                        detail="Request pricing & availability"
                        startVisible={false}
                        proid={id}
                        ondeffCode='junkRemovalQuoteRequest'
                        class="get-a-quote"
                    />
                ) 
            } else{
                return (
                    <CallToActionDescription 
                        detail=""
                        startVisible={false}
                        proid={id}
                        ondeffCode='priceAndAvailabilityForm'
                        class="get-a-quote view-prices-and-availability"
                        btnLabel='Get pricing & availability'
                    />
                )  
            }
        }
    }

    getProUrl = (data) => {
        const url = data.split(/data-url="([^"]+)/)
        return url?.length === 3 ? url[1] : '/book';
    }

    handleRedirect = (data) => {
        const proUrl = this.getProUrl(data);
        if(proUrl){
            window.location.href = proUrl;
        }
    }

    handleCallBackAfterSubmit = (formData) => {
        const formattedData = formatBookingJson(formData);
        if(formattedData?.pro_id && this.profilesById[formattedData.pro_id]) {
            manualGoogleEvents('manualFormSubmition');
            this.handleRedirect(this.profilesById[formattedData.pro_id])
        }
    }

    render() {
        const handleClick = async (e) => {
            e.preventDefault();
            var profilesByIdAux = this.profilesById
            const localCode = this.code === 'dumpster' ? 'dumpster-rental' : this.code === 'comercial-trash-service' ? 'commercial-waste-management' : this.code
            this.page = this.page + 1;
            const previousCount = this.defaultCards + (this.page - 1) * this.cardsPerPage;
            await Promise.all(this.profiles.slice(this.defaultCards + ((this.page - 1)*this.cardsPerPage), (this.defaultCards + this.page*this.cardsPerPage)).map((profile, index) => {
                return fetch('/pros/' + localCode + '/' + profile.id + '.html')
                .then(res => {
                    return res.text();
                })
                .then(res => {
                    if (res.startsWith("<div class=\"flex-head\"")) {
                        res = res.replace(/\[place\]/g, this.place.name);
                        profilesByIdAux[profile.id] = res;
                        return profile
                    }
                    else {
                        throw new Error('Invalid card');
                    }
                    
                }).catch((error) => {
                    profile.remove = 1
                    return profile
                });
            })).then(() => {
                this.setState({
                    profilesById: profilesByIdAux
                })
                return this.forceUpdate()
            })
            trackProCardsViewsOnViewport(this.eventClass, this.cardClass, previousCount);
            return         
        }

        return (
            <div className="items-grid prof dumpster">
                <div className="container">
                    <div id="profiles-cards-list" className="row">
                        {
                            this.profiles.slice(0, (this.paginated ? (this.defaultCards + this.page*this.cardsPerPage) : this.profiles.length)).filter(item => item.remove != 1).map((profile, index) => {
                               const pro = profile
                               if(this.profilesById[pro.id]){
                                    return (
                                        <div data-proid={pro.id} key={index} className={this.cardClass}>
                                            <div data-id={pro.id} className="item" >
                                                <div dangerouslySetInnerHTML={{__html: this.profilesById[pro.id]}} onClick={() => this.handleRedirect(this.profilesById[pro.id])}>
                                                
                                                </div>
                                                {this.addQuote(pro.id)} 
                                            </div>
                                        </div>
                                    )
                                }else{
                                    profile.remove = 1
                                    return <></>
                                }  
                            })
                        }
                    </div>
                    {this.paginated && this.profiles?.length > (this.defaultCards + this.page*this.cardsPerPage) &&
                    <div className="load-more-container">
                        <button onClick={handleClick} className="load-more-btn">Show More</button>
                    </div>
                   }
                </div>
            </div>
        )
    }
}